import { useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';

import WorkQueues from 'enums/workQueue.enum';
import { listFillLaterByPage } from 'store/thunks/workQueueThunks';
import { useWorkQueueTabSwitch } from '../contexts/WorkQueueTabSwitchContext';

import FillLaterQueueFilterButton from './FillLaterQueueFilterButton';
import FillLaterQueueFilterStatusBar from './FillLaterQueueFilterStatusBar';
import FillLaterQueueOuterFilter from './FillLaterQueueOuterFilter';
import FillLaterQueueTable from './FillLaterQueueTable';

/**
 * Fill Later work queue (POM-6149): everything scheduled to be filled later, so held quantity is
 * visible and manageable. Layout follows the Bulk tab exactly: active-filter chips on the left
 * (they take the free width), then the outer date range and the Filters button on the right,
 * then the table. Putting the date range first made it collide with the chips.
 */
const FillLaterQueue = () => {
  const dispatch = useDispatch();
  const preset = useSelector(({ workQueue }) => workQueue.preset);
  const { currentPage } = useSelector(({ workQueue }) => workQueue.fillLater, shallowEqual);
  const { isTabSwitch } = useWorkQueueTabSwitch();

  useEffect(() => {
    if (isTabSwitch(WorkQueues.FILL_LATER)) {
      dispatch(listFillLaterByPage({ page: currentPage }));
    }
  }, [dispatch, currentPage, isTabSwitch]);

  if (preset !== WorkQueues.FILL_LATER) {
    return null;
  }

  return (
    <Grid container sx={{ py: 2 }} alignItems='center' spacing={1}>
      <Grid item sx={{ minHeight: 40, flexGrow: 2 }}>
        <FillLaterQueueFilterStatusBar />
      </Grid>
      <Grid item>
        <FillLaterQueueOuterFilter />
      </Grid>
      <Grid item>
        <FillLaterQueueFilterButton />
      </Grid>
      <FillLaterQueueTable />
    </Grid>
  );
};

export default FillLaterQueue;
